'use client';

import React from 'react';
import { MegaFooter } from '@/components/ui/home/mega-footer';
import { useFooter } from '@/contexts/FooterContext';

type ConditionalFooterProps = {
  contactData: any;
  aboutData: any;
};

export function ConditionalFooter({ contactData, aboutData }: ConditionalFooterProps) {
  const { showFooter } = useFooter();
  
  if (!showFooter) return null;
  
  return <MegaFooter contactData={contactData} aboutData={aboutData} />;
}
